import { render, staticRenderFns } from "./ListUserSeen.vue?vue&type=template&id=8ec428dc"
import script from "./ListUserSeen.vue?vue&type=script&lang=js"
export * from "./ListUserSeen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports